import React, { useMemo, useState } from 'react';
import { Select, Tabs } from '@maxtropy/components';
import { TabsProps } from 'antd/es/tabs';
import classNames from 'classnames';
import { uniqBy } from 'lodash-es';
import styles from './index.module.scss';
import { SearchOutlined } from '@ant-design/icons';

export interface TabDataType {
  key: string;
  name: string;
}

export interface DeviceTabProps extends Partial<TabsProps> {
  onTabChange?: (tabTile: string) => void;
  tabData: TabDataType[];
  activeKey?: string;
  className?: string;
  extral?: React.ReactNode;
}

const DeviceTab: React.FC<DeviceTabProps> = props => {
  const { onTabChange, tabData = [], activeKey, className, extral } = props;
  const [isSearching, setIsSearching] = useState<boolean>(false);

  const TabSelectRender = useMemo(() => {
    return (
      <div className={styles.searchMenu}>
        <SearchOutlined
          className={`${styles.searchIcon} ${isSearching && styles.focusedSearch}`}
          onClick={() => setIsSearching(prev => !prev)}
        />
        {isSearching && (
          <div className={styles.searchMenuPanel}>
            <Select
              options={tabData.map(i => ({
                label: i.name,
                name: i.name,
                value: i.key,
              }))}
              optionFilterProp="name"
              style={{ width: '100%' }}
              showSearch
              placeholder="请输入数据属性名称"
              popupMatchSelectWidth={false}
              onSelect={value => {
                setIsSearching(false);
                onTabChange?.(value);
              }}
            />
          </div>
        )}
      </div>
    );
  }, [tabData, activeKey, isSearching]);

  return (
    <div className={classNames(styles.tabs, className)}>
      <div className={styles.tab_box}>
        <Tabs
          onChange={onTabChange}
          activeKey={activeKey}
          items={uniqBy(tabData, 'key').map(item => ({ key: item.key, label: item.name }))}
        />
      </div>
      <div className={styles.extral_box}>
        {TabSelectRender}
        {extral}
      </div>
    </div>
  );
};

export default DeviceTab;
